export default __webpack_public_path__ + "static/media/girl-with-headphones-pointing.acad90e2.png";